import {GiftingReceiver} from '@web/core/constants'
import makeSlice from '@web/slices/gift/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'
import {getGiftingByApi} from '../../utils/apiHelper'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {
                friendsSessionKey,
                receivers,
                availableGiftingPeopleCount,
                playerKeys,
                existsECouponCategoryProduct,
            } = payload.data.gifting ?? getGiftingByApi()

            state.existsECouponCategoryProduct = existsECouponCategoryProduct ?? false
            state.sessionKey = friendsSessionKey
            state.availableCount = availableGiftingPeopleCount

            state.receivers = receivers.map((receiver, index) => {
                return {
                    type: receiver.receiverType,
                    friendSelectionType: receiver.orderSheetFriendSelectionType,
                    kakaoRealName: receiver.kakaoRealName,
                    name:
                        receiver.receiverType === GiftingReceiver.RCVTP_003
                            ? (receiver.kakaoRealName ?? '')
                            : receiver.name,
                    phone: '',
                    key: receiver.receiverKey,
                    playerKey: playerKeys[index] ?? null,
                    profileImage: receiver.receiverProfileImage,
                    nidNo: receiver.nidNo,
                }
            })
        })
    },
})

export default slice.reducer
